export const EMPTY_FIDUCIARI_CONFIG = Object.freeze({
  tipiFiduciario: [],
  tipiIncarico: [],
});

export const SEARCH_CONTEXT = Object.freeze({
  PORTAL: 'SI',
  OXS: 'NO',
});

export const FIDUCIARI_QUERY_PARAM = Object.freeze({
  IS_PORTAL: 'isPortal',
  CAP: 'cap',
  TIPO_PERIZIA: 'tipoPerizia',
  TIPO_FIDUCIARIO: 'tipoFiduciario',
  COMPETENZA: 'competenza',
  SPECIALIZZAZIONE: 'specializzazione',
  AREA_GEOGRAFICA_COMPETENZA: 'areaGeograficaCompetenza',
  AREA_GEOGRAFICA_ID: 'areaGeograficaId',
});

export const FIDUCIARI_SEARCH_ERROR = Object.freeze({
  MISSING_PORTAL_REQUIRED: 'Per ricerca Portal sono obbligatori CAP e Tipo perizia.',
  MISSING_OXS_REQUIRED: 'Per ricerca OXS sono obbligatori Tipo fiduciario, Competenza e Area geografica competenza.',
  MISSING_OXS_AREA_ID: 'Per ricerca OXS regionale o provinciale è obbligatoria la selezione geografica.',
  INVALID_OXS_AREA: 'Area geografica competenza non valida.',
  SEARCH_FAILED: 'Errore durante la ricerca fiduciari',
});

export const resolveSearchContext = (suPortale) => (
  suPortale === SEARCH_CONTEXT.PORTAL ? SEARCH_CONTEXT.PORTAL : SEARCH_CONTEXT.OXS
);

const normalizeSpecializzazione = (item = {}) => ({
  id: item?.id || '',
  codice: item?.codice || '',
  descrizione: item?.descrizione || '',
});

const normalizeCompetenza = (item = {}) => ({
  id: item?.id || '',
  codice: item?.codice || '',
  descrizione: item?.descrizione || '',
  specializzazioni: Array.isArray(item?.specializzazioni)
    ? item.specializzazioni.map((spec) => normalizeSpecializzazione(spec))
    : [],
});

const normalizeTipoFiduciario = (item = {}) => ({
  id: item?.id || '',
  codice: item?.codice || '',
  descrizione: item?.descrizione || '',
  attivo: item?.attivo ?? true,
  competenze: Array.isArray(item?.competenze)
    ? item.competenze.map((comp) => normalizeCompetenza(comp))
    : [],
});

// CSP-3450: `attivo` distingue i tipi perizia MSA in uso da quelli dismessi.
// Se il BE non lo manda il tipo resta attivo, come per i tipi fiduciario.
const normalizeTipoIncarico = (item = {}) => ({
  id: item?.id || '',
  codice: item?.codice || '',
  descrizione: item?.descrizione || '',
  attivo: item?.attivo ?? true,
});

export const normalizeFiduciariConfigModel = (data = {}) => ({
  tipiFiduciario: Array.isArray(data?.tipiFiduciario)
    ? data.tipiFiduciario.map((item) => normalizeTipoFiduciario(item))
    : EMPTY_FIDUCIARI_CONFIG.tipiFiduciario,
  tipiIncarico: Array.isArray(data?.tipiIncarico)
    ? data.tipiIncarico.map((item) => normalizeTipoIncarico(item))
    : EMPTY_FIDUCIARI_CONFIG.tipiIncarico,
});

export const EMPTY_FIDUCIARIO_SOGGETTO = Object.freeze({
  nome: null,
  cognome: null,
  denominazione: '-',
  codiceFiscale: '',
  partitaIva: '',
  email: '',
  telefono: '',
  indirizzo: '-',
});

export const createFiduciarioListItemModel = (overrides = {}) => ({
  id: '',
  codiceFiduciario: '',
  soggetto: { ...EMPTY_FIDUCIARIO_SOGGETTO },
  competenza: '-',
  specializzazione: '-',
  accordoQuadro: false,
  correlato: false,
  note: '-',
  suPortale: false,
  portal: false,
  attivo: true,
  externalId: null,
  portalRawId: null,
  ...overrides,
});

/**
 * Estrae gli elementi della ricerca fiduciari in modo retrocompatibile
 * con i vari envelope BE:
 * - nuovo OXS paginato: data.content
 * - legacy OXS: data.fiduciari
 * - Portal: data.value.trustees
 */
export const extractRicercaFiduciariItems = (data = {}) => {
  if (Array.isArray(data?.value?.trustees)) {
    return { source: 'portalTrustees', items: data.value.trustees };
  }
  if (Array.isArray(data?.content)) {
    return { source: 'content', items: data.content };
  }
  if (Array.isArray(data?.fiduciari)) {
    return { source: 'fiduciari', items: data.fiduciari };
  }
  return { source: 'none', items: [] };
};
